import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { AngularFireAuthGuard } from "@angular/fire/compat/auth-guard";
import { RouterModule, Routes } from "@angular/router";
import { AuthService } from "@core/auth.service";

import { IonicModule } from "@ionic/angular";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import player from 'lottie-web';
import { LottieComponent, provideLottieOptions } from "ngx-lottie";
import { ComponentModule } from "src/app/components/component.module";
import { LoadingScreenComponent } from "src/app/components/loading-screen/loading-screen.component";
import { LoadingComponent } from "src/app/components/loading/loading.component";
import { DirectiveModule } from "src/app/directives/directive.module";
import { FirestoreTransLoader } from "src/app/services/firestore.service";
import { SwiperModule } from "swiper/angular";
import { CheckedManagedTicketComponent } from "../syndicate/tickets/checked-managed-ticket/checked-managed-ticket.component";
import { BreakdownComponent } from "./breakdown/breakdown.component";
import { CheckWinningsRepositoryService } from "./check-winnings-repository.service";
import { CheckWinningsSplashComponent } from "./check-winnings-splash/check-winnings-splash.component";
import { CheckWinningsComponent } from "./check-winnings.component";
import { CheckedTicketsComponent } from "./checked-tickets/checked-tickets.component";
import { ConvertToCashComponent } from "./convert-to-cash/convert-to-cash.component";
import { PrizeDrawLoseComponent } from "./prize-draw-lose/prize-draw-lose.component";
import { SurpriseGiftComponent } from "./surprise-gift/surprise-gift.component";
import { ThumbAnimationComponent } from "./thumb-animation/thumb-animation.component";
// export function createTranslateLoader(http: HttpClient) {
//   return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
// }
export function FirestoreTranslationsLoaderFactory(http: HttpClient, authService: AuthService) {
  return new FirestoreTransLoader(http);
}
const routes: Routes = [
  {
    path: "",
    component: CheckWinningsComponent,
    canActivate: [AngularFireAuthGuard],
  },
  {
    path: "breakdown/:id",
    component: BreakdownComponent,
    canActivate: [AngularFireAuthGuard],
  },
  {
    path: "checkWinningsSplash",
    component: CheckWinningsSplashComponent,
    canActivate: [AngularFireAuthGuard],
  },
  {
    path: "surprise-gift",
    component: SurpriseGiftComponent,
    canActivate: [AngularFireAuthGuard],
  },
 {
  path: "checkedManagedTickets",
  component: CheckedManagedTicketComponent,
  canActivate: [AngularFireAuthGuard],
},
{
  path: "prize-draw-lose",
  component: PrizeDrawLoseComponent,
  canActivate: [AngularFireAuthGuard],
},
];

export function playerFactory() {
  // add this line
  return import("lottie-web"); // add this line
}
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    IonicModule,
    ComponentModule,
    DirectiveModule,
    SwiperModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: FirestoreTranslationsLoaderFactory,
        deps: [HttpClient, AuthService],
      },
      defaultLanguage: "en",
    }),
    LottieComponent,
    CheckWinningsComponent,
    ConvertToCashComponent,
    CheckedTicketsComponent,
    CheckWinningsSplashComponent,
    LoadingScreenComponent,
    LoadingComponent,
    BreakdownComponent,
    CheckedManagedTicketComponent,
    ThumbAnimationComponent,
    SurpriseGiftComponent,
  ],
  exports: [RouterModule],
  providers: [
    CheckWinningsRepositoryService,
    provideLottieOptions({
      player: () => player,
    }),
  ],
})
export class CheckWinningsModule { }
